import { render, staticRenderFns } from "./ClipBoard.vue?vue&type=template&id=f2450d12&scoped=true&"
import script from "./ClipBoard.vue?vue&type=script&lang=js&"
export * from "./ClipBoard.vue?vue&type=script&lang=js&"
import style0 from "./ClipBoard.vue?vue&type=style&index=0&id=f2450d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2450d12",
  null
  
)

export default component.exports